export class CatSubProductModel {
    public iCatSubProductId?: number;
    public vDescription?: string;
    public iCatProductId?: number;
    public iActiveId?: number;
    public vCreateUserId?: string;
    public dtCreateDate?: string;
    public vModifUserId?: string;
    public dtModifDate?: string;
}
